import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M11.328 21.25h6.7c.85 0 1.5-.65 1.5-1.5V7.25h-3.5c-.55 0-1-.45-1-1v-3.5M12.278 2.75h-5.75c-.85 0-1.5.65-1.5 1.5v15.5c0 .85.65 1.5 1.5 1.5h1.95M19.528 7.25l-4.5-4.5"
    }, null, -1)
  ]))]))
}
export default { render: render }